import { call, put, delay } from 'redux-saga/effects';
import processError from '../../../utils/processError';
import { szltHelperFailed, szltHelperSuccessful } from '../actions';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import makeRequest from '../../../utils/makeRequest';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { OK } from '../../../configs/serverStatusCodes';
import { BACKEND_URL, DEFAULT_ITEMS_OF_PAGE, LOADING_DELAY } from '../../../configs';
import addFilterQueryWithCondition from '../../../utils/addFilterQueryWithCondition';

export default function* szltHelper(action) {
  try {
    let pool = {
      limit: 10,
      page: 1,
    };
    let filter = {};
    if (typeof action.payload === 'string') {
      filter.number = action.payload;
    }
    if (Array.isArray(action.payload)) {
      filter.numbers = action.payload;
    }
    if (typeof action.payload === 'object') {
      filter = action.payload;
    }
    pool = addFilterQueryWithCondition(filter, pool);
    yield delay(LOADING_DELAY);
    const url = `${BACKEND_URL}/proxy/backend/api/v1/registries/order-services`;
    const dataResponse = yield makeRequest(url, pool, action, 'GET', true);
    const data = yield dataResponse.json();
    if (dataResponse.status === OK) {
      yield put(szltHelperSuccessful(data));
      yield call(resolveActionPromise(action, data.data));
    } else {
      yield put(szltHelperFailed());
      yield call(rejectActionPromise(action, data));
    }
  } catch (e) {
    yield put(szltHelperFailed());
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  } finally {
    yield call(resolveActionPromise(action));
  }
}
